import { FilterGroup } from 'components/filter/types';
import { v4 as uuid } from 'uuid';

const uuidSingleton = uuid();

const defaultFilterGroups: FilterGroup[] = [
    {
        id: uuidSingleton,
        innerOperator: 'and',
        outerOperator: 'and',
        filters: [],
    },
];

export { uuidSingleton, defaultFilterGroups };
